import type { CalculationType, CalculatorField } from '../../../../types';

const buildFieldId = (value: string = ''): string => {
  return value.trim().replace(/\s+/g, '-').toLowerCase();
};

const getFieldLabel = (field: CalculatorField | CalculationType) => {
  if ('name' in field) {
    const { name, id } = field;
    return name ?? id ?? '';
  }

  if ('label' in field) {
    const { label, id } = field;
    return label ?? id ?? '';
  }

  return undefined;
};

export const buildFieldIdForField = (
  field: CalculatorField | CalculationType
): string => {
  const label = getFieldLabel(field);

  return buildFieldId(label);
};
